import React, { useState, useEffect } from 'react';

import styled, { css } from 'styled-components';
import CommenButton from '../common/Button';
import { inputNumberAutoComma } from '../../lib/commonFunc/commonFunc'
import Select from 'react-select';
import palette from '../../lib/styles/palette';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import TextField from '@material-ui/core/TextField';

const Wrapper = styled.div`
  margin-top: 24px;
  padding-bottom: 40px;
`;

const Table = styled.table`
  font-family: 'Noto Sans KR', sans-serif;
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;

  th, td {
    border: 1px solid #e0e4ea;
    padding: 8px 12px;
    text-align: center;
  }

  thead td,
  thead th {
    background: #f5f7fa;
    font-weight: 700;
    color: #2c3e50;
    white-space: nowrap;
  }

  tbody td {
    color: #555;
  }

  tbody tr:hover {
    background: #f9fbfd;
  }
`;

const TextSpace = styled.div`
  padding: 0 12px;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  color: #868e96;
`;

const DateBlock = styled.td`
  padding: 8px 12px;
  font-weight: 600;
`;
const Line = styled.div`
    width: 100%;
    padding: 20px 10px;
    margin-bottom: 60px;
    border-bottom: 1px solid #e0e4ea;
    padding-bottom: 60px;
`;
const TabBlock = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 28px;
  border-bottom: 1px solid #e0e4ea;
`;
const TabText = styled.div`
  font-size: 1.05rem;
  cursor: pointer;
  padding: 12px 20px;
  color: #868e96;
  border-bottom: 2px solid transparent;
  transition: color 0.15s ease, border-color 0.15s ease;

  &:hover {
    color: #2c3e50;
  }

  ${(props) =>
        props.active &&
        css`
      font-weight: 700;
      color: ${palette.webCyan[5]};
      border-bottom-color: ${palette.webCyan[5]};
    `}
`;

const SectionWrapper = styled.div`
  margin-bottom: 40px;
  background: #fff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 18px 24px;
  background: #f8f9fb;
  border-bottom: 1px solid #e0e4ea;
`;

const SectionTitle = styled.h3`
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #2c3e50;
`;

const SectionBody = styled.div`
  padding: 24px;
`;

const FilterRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 20px 24px;
  background: #f8f9fb;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  margin-bottom: 24px;
`;

const FilterLabel = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  color: #2c3e50;
`;

const SummaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 24px;
  margin-bottom: 16px;
  font-size: 0.95rem;
  color: #555;

  strong {
    color: #2c3e50;
    font-weight: 700;
  }
`;

const CompareSection = styled.div`
  margin-bottom: 40px;
  background: #fff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: visible;
`;

const CompareHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 18px 24px;
  background: #f8f9fb;
  border-bottom: 1px solid #e0e4ea;
  border-radius: 12px 12px 0 0;
`;

const CompareTitle = styled.h3`
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #2c3e50;
`;

const CompareBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const CompareSummaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  color: #555;
  font-size: 0.95rem;
`;

const CompareMessage = styled.div`
  color: #868e96;
  font-size: 0.9rem;
`;

const downloadExcel = (date, tableName) => {
    const table = document.getElementsByClassName(tableName)[0];
  
    let tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text +=
      '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
    tab_text += '<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
    tab_text += '<x:Name>Test Sheet</x:Name>';
    tab_text +=
      '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text += '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    tab_text += "<table border='1px'>";
  
    let exportTable = table.cloneNode(true);
  
    tab_text += exportTable.outerHTML;
    tab_text += '</table></body></html>';
    let data_type = 'data:application/vnd.ms-excel';
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf('MSIE ');
    let fileName = date + '_Table' + '.xls';
  
    // browser 처리
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      //ie 용
      if (window.navigator.msSaveBlob) {
        let blob = new Blob([tab_text], {
          type: 'application/csv;charset=utf-8;',
        });
        navigator.msSaveBlob(blob, fileName);
      }
    } else {
      //그외
      let blob2 = new Blob([tab_text], {
        type: 'application/csv;charset=utf-8;',
      });
      let filename = fileName;
      let elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob2);
      elem.download = filename;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
};

const AdminClubTransferCalculate = ({
    clubTransferCalculate,
    startTime,
    endTime,
    setStartTime,
    setEndTime,
    onClickPeriod,
    onCompare,
    compareResults = [],
    compareSummary = null,
}) => {

    const [activeType, setActiveType] = useState('total');
    const [compareClubFilter, setCompareClubFilter] = useState(0);
    const [clubTabFilter, setClubTabFilter] = useState(0);
    const [invoiceMonth, setInvoiceMonth] = useState(() => {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
    });
    const normalizeDateKey = (timestamp) => {
        const date = new Date(timestamp * 1000);
        date.setHours(0, 0, 0, 0);
        return {
            normalizedTimestamp: Math.floor(date.getTime() / 1000),
        };
    };
    const changeDateFormat = (timestamp) => {
        const date = new Date(timestamp * 1000);
        const year1 = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const dateStr = `${year1}-${month}-${day}`;

        return dateStr
    }

    const getMonthBounds = (monthValue) => {
        if (!monthValue) return null;
        const [year, month] = monthValue.split('-').map(Number);
        if (!year || !month) return null;
        const start = new Date(year, month - 1, 1);
        start.setHours(0, 0, 0, 0);
        const end = new Date(year, month, 0);
        end.setHours(23, 59, 59, 0);
        return {
            startTime: Math.floor(start.getTime() / 1000),
            endTime: Math.floor(end.getTime() / 1000),
        };
    };

    const isMonthTab = activeType === 'month';

    useEffect(() => {
        if (!isMonthTab) return;
        const bounds = getMonthBounds(invoiceMonth);
        if (!bounds) return;
        const { startTime: monthStart, endTime: monthEnd } = bounds;
        if (startTime !== monthStart || endTime !== monthEnd) {
            setStartTime(monthStart);
            setEndTime(monthEnd);
        }
    }, [isMonthTab, invoiceMonth, startTime, endTime, setStartTime, setEndTime]);

    const handleInvoiceMonthChange = (value) => {
        setInvoiceMonth(value);
        const bounds = getMonthBounds(value);
        if (!bounds) return;
        const { startTime: monthStart, endTime: monthEnd } = bounds;
        if (startTime !== monthStart || endTime !== monthEnd) {
            setStartTime(monthStart);
            setEndTime(monthEnd);
        }
    };

    // 클럽번호 오름차순, 같은 클럽은 이체 실행일 최신순
    const compareClub = (a, b) =>
        (Number(a.clubID) || 0) - (Number(b.clubID) || 0) || (b.registTime || 0) - (a.registTime || 0);

    const calculateData = Array.isArray(clubTransferCalculate) ? [...clubTransferCalculate].sort(compareClub) : [];

    let clubList = [{label:'전체', value:0}];

    for (let i = 0; i < calculateData.length; i++) {
        let skip = false;
        for (let j = 0; j < clubList.length; j++) {
            if(clubList[j].value == calculateData[i].clubID)
            {
                skip = true;
                break;
            }
        }

        if(!skip)
        {
            clubList.push({label:calculateData[i].clubName, value:calculateData[i].clubID});
        }
    }

    const normalizedData = activeType === 'total'
        ? calculateData.reduce((acc, item) => {
              const normalizedTimestamp = normalizeDateKey(item.registTime).normalizedTimestamp;
              const key = normalizedTimestamp;
              const existing = acc.get(key);
              if (existing) {
                  existing.totalPrice += item.totalPrice || 0;
                  existing.fees += item.fees || 0;
                  existing.transferPrice += item.transferPrice || 0;
              } else {
                  acc.set(key, {
                      registTime: normalizedTimestamp,
                      registDate: item.registDate,
                      transferDateLangth: item.transferDateLangth,
                      totalPrice: item.totalPrice || 0,
                      fees: item.fees || 0,
                      transferPrice: item.transferPrice || 0,
                  });
              }
              return acc;
          }, new Map())
        : null;

    const monthBounds = isMonthTab ? getMonthBounds(invoiceMonth) : null;

    let filteredCalculateData = [];
    if (activeType === 'total') {
        filteredCalculateData = Array.from(normalizedData.values()).sort(
            (a, b) => b.registTime - a.registTime,
        );
    } else if (activeType === 'club') {
        filteredCalculateData = calculateData.filter((item) => {
            if (clubTabFilter !== 0 && item.clubID !== clubTabFilter) {
                return false;
            }
            return true;
        });
    } else if (isMonthTab) {
        filteredCalculateData = calculateData.filter((item) => {
            if (!monthBounds) return false;
            if (item.registTime < monthBounds.startTime || item.registTime > monthBounds.endTime) {
                return false;
            }
            return true;
        });
    }

    const invoiceAggregated =
        isMonthTab && filteredCalculateData.length > 0
            ? filteredCalculateData.reduce((acc, item) => {
                  const existing = acc.get(item.clubID);
                  if (existing) {
                      existing.totalPrice += item.totalPrice || 0;
                      existing.fees += item.fees || 0;
                      existing.transferPrice += item.transferPrice || 0;
                  } else {
                      acc.set(item.clubID, {
                          clubName: item.clubName,
                          clubID: item.clubID,
                          totalPrice: item.totalPrice || 0,
                          fees: item.fees || 0,
                          transferPrice: item.transferPrice || 0,
                      });
                  }
                  return acc;
              }, new Map())
            : null;

    const displayRows =
        isMonthTab && invoiceAggregated
            ? Array.from(invoiceAggregated.values()).sort(compareClub)
            : filteredCalculateData;

    const totals = (displayRows || []).reduce(
        (acc, item) => {
            acc.totalPrice += item.totalPrice || 0;
            acc.fees += item.fees || 0;
            acc.transferPrice += item.transferPrice || 0;
            return acc;
        },
        { totalPrice: 0, fees: 0, transferPrice: 0 },
    );

    const compareSelectValue =
        clubList.find((option) => option.value === compareClubFilter) || clubList[0];

    const clubTabSelectValue =
        clubList.find((option) => option.value === clubTabFilter) || clubList[0];

    const excelTitle =
        activeType === 'month'
            ? `${invoiceMonth} 세금 계산서`
            : '클럽별 정산 금액';

    const handleTabChange = (type) => {
        setActiveType(type);
        if (type === 'total') {
            setClubTabFilter(0);
        }
        if (type === 'month') {
            const bounds = getMonthBounds(invoiceMonth);
            if (bounds) {
                setStartTime(bounds.startTime);
                setEndTime(bounds.endTime);
            }
        }
    };

  return (
    <>
    <Wrapper>
        <TabBlock>
            <div style={{ display: 'flex' }}>
                <TabText
                    onClick={() => handleTabChange('total')}
                    active={activeType === 'total'}
                >
                    전체
                </TabText>
                <TabText
                    onClick={() => handleTabChange('club')}
                    active={activeType === 'club'}
                >
                    클럽별
                </TabText>
                <TabText
                    onClick={() => handleTabChange('month')}
                    active={activeType === 'month'}
                >
                    세금 계산서
                </TabText>
            </div>
        </TabBlock>
        <FilterRow>
            <TextField
                id="startTime"
                label="시작일"
                name="startTime"
                type="date"
                value={changeDateFormat(startTime)}
                disabled={isMonthTab}
                onChange={(e) =>{
                    let date = new Date(e.target.value)

                    date.setHours(0, 0, 0, 0)

                    setStartTime(parseInt(date.getTime()/1000))
                }}
                InputLabelProps={{
                    shrink: true,
            }}
            />
            <TextSpace>~</TextSpace>
            <TextField
                id="endTime"
                label="종료일"
                name="endTime"
                type="date"
                value={changeDateFormat(endTime)}
                disabled={isMonthTab}
                onChange={(e) =>{
                    let date = new Date(e.target.value)

                    date.setHours(23, 59, 59)

                    setEndTime(parseInt(date.getTime()/1000))
                }}
                InputLabelProps={{
                    shrink: true,
            }}
            />
            <div style={{width:'20px'}}/>
            <ButtonGroup
                color="primary"
                aria-label="outlined primary button group"
            >
                <Button onClick={() => onClickPeriod('month')} disabled={isMonthTab}>1달</Button>
                <Button onClick={() => onClickPeriod('3months')} disabled={isMonthTab}>3달</Button>
                <Button onClick={() => onClickPeriod('6months')} disabled={isMonthTab}>6달</Button>
                <Button onClick={() => onClickPeriod('')} disabled={isMonthTab}>전체</Button>
            </ButtonGroup>
        </FilterRow>
        {activeType === 'club' && (
        <div style={{marginBottom: '24px'}}>
            <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '12px'}}>
                <FilterLabel style={{minWidth: '50px'}}>클럽 : </FilterLabel>
                <Select
                    options={clubList}
                        value={clubTabSelectValue}
                        onChange={(option)=>{
                            setClubTabFilter(option.value);
                    }}
                    isSearchable={false}
                    styles={{ 
                        container: provided => ({...provided, width: '400px', padding: 0, border: 0})
                    }}
                    height="450px"
                    aria-labelledby="select"
                    placeholder="클럽 선택"
                    maxMenuHeight={'450px'}
                />
            </div>
        </div>
        )}
        {isMonthTab && (
            <div style={{marginBottom: '24px'}}>
                <div style={{width: '100%', display: 'flex', alignItems: 'center', gap:'12px'}}>
                    <FilterLabel style={{minWidth: '70px'}}>대상 월</FilterLabel>
                    <TextField
                        id="invoiceMonth"
                        name="invoiceMonth"
                        type="month"
                        value={invoiceMonth}
                        onChange={(e) => handleInvoiceMonthChange(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </div>
            </div>
        )}
        {activeType === 'total' && (
            <CompareSection>
                <CompareHeader>
                    <CompareTitle>이체 정산 비교</CompareTitle>
                    <div style={{display:'flex', alignItems:'center', gap:'12px', flexWrap:'wrap'}}>
                        <Select
                            options={clubList}
                            value={compareSelectValue}
                            onChange={(option)=>{
                                setCompareClubFilter(option.value);
                            }}
                            isSearchable={false}
                            styles={{ 
                                container: provided => ({...provided, width: '220px', padding: 0, border: 0})
                            }}
                            height="320px"
                            aria-labelledby="compare-select"
                            placeholder="클럽 선택"
                            maxMenuHeight={'320px'}
                        />
                        <CommenButton onClick={() => onCompare(compareClubFilter)}>
                            비교하기
                        </CommenButton>
                    </div>
                </CompareHeader>
                <CompareBody>
                {
                    compareResults.length === 0 ? (
                        <CompareMessage>비교 결과가 없습니다. 기간과 클럽을 선택한 뒤 비교하기 버튼을 눌러주세요.</CompareMessage>
                    ) : (
                        <>
                            {compareSummary && (
                                <CompareSummaryRow>
                                    <div>계산 총 결제 금액: {inputNumberAutoComma(compareSummary.calculation.totalPrice)}</div>
                                    <div>실제 총 결제 금액: {inputNumberAutoComma(compareSummary.actual.totalPrice)}</div>
                                    <div>
                                        차이:{' '}
                                        <span style={{ color: compareSummary.diff.totalPrice === 0 ? '#868e96' : '#e74c3c' }}>
                                            {inputNumberAutoComma(compareSummary.diff.totalPrice)}
                                        </span>
                                    </div>
                                </CompareSummaryRow>
                            )}
                            <Table>
                                <thead>
                                    <tr>
                                        <td>클럽번호</td>
                                        <td>클럽 이름</td>
                                        <td>이체 실행일</td>
                                        <td>계산 이체금</td>
                                        <td>실제 이체금</td>
                                        <td>차이</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...compareResults]
                                        .sort(compareClub)
                                        .filter((result) => result.diff.transferPrice !== 0)
                                        .map((result, idx) => {
                                            const calculateValue = result.calculateTotal?.transferPrice ?? 0;
                                            const actualValue = result.actualTotal?.transferPrice ?? 0;
                                            const diffValue = result.diff.transferPrice;
                                            const diffSign = diffValue > 0 ? '+' : '';
                                            const dateText = result.registDateLabel
                                                ? result.registDateLabel.replace(/-/g, '.')
                                                : new Date(result.registTime * 1000).toLocaleDateString();
                                            const hasCalculate = !!result.calculateGroup;
                                            const hasActual = !!result.actualGroup;

                                            return (
                                                <tr key={`${idx}`}>
                                                    <td>{result.clubID || '-'}</td>
                                                    <td>{result.clubName || '-'}</td>
                                                    <td>{dateText}</td>
                                                    <td>{hasCalculate ? inputNumberAutoComma(calculateValue) : '-'}</td>
                                                    <td>{hasActual ? inputNumberAutoComma(actualValue) : '-'}</td>
                                                    <td style={{ color: diffValue === 0 ? '#868e96' : '#e74c3c' }}>
                                                        {`${diffSign}${inputNumberAutoComma(diffValue)}`}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </Table>
                        </>
                    )
                }
                </CompareBody>
            </CompareSection>
        )}
        <SectionWrapper>
            <SectionHeader>
                <SectionTitle>
                    {activeType === 'month' ? '세금 계산서 (월별 클럽 합산)' : '클럽별 정산 금액'}
                </SectionTitle>
                <CommenButton
                    onClick={() => downloadExcel(excelTitle, 'transferCalculate')}
                >{`Excel 다운로드`}</CommenButton>
            </SectionHeader>
            <SectionBody>
            <SummaryRow>
                <div>총 결제 금액 : <strong>{inputNumberAutoComma(totals.totalPrice)}</strong></div>
                <div>총 수수료 : <strong>{inputNumberAutoComma(totals.fees)}</strong></div>
                <div>총 이체 금액 : <strong>{inputNumberAutoComma(totals.transferPrice)}</strong></div>
            </SummaryRow>
        <Table className="transferCalculate">
            <thead>
                <tr>
                {activeType === 'total' ? (
                    <>
                        <td>이체 실행일</td>
                        <td>결제 기간</td>
                        <td>결제 금액</td>
                        <td>수수료</td>
                        <td>이체 금액</td>
                    </>
                ) : activeType === 'club' ? (
                    <>
                <td>클럽번호</td>
                <td>클럽 이름</td>
                <td>이체 실행일</td>
                <td>결제 기간</td>
                <td>결제 금액</td>
                <td>수수료</td>
                <td>이체 금액</td>
                    </>
                ) : (
                    <>
                        <td>클럽번호</td>
                        <td>클럽 이름</td>
                        <td>총 결제 금액</td>
                        <td>총 수수료</td>
                        <td>총 이체 금액</td>
                    </>
                )}
                </tr>
            </thead>
            <tbody>
                {
                    displayRows && displayRows.map((dateData, idx1)=>{
                        return (
                        <tr
                            key={idx1}
                        >
                            {activeType === 'total' ? (
                                <>
                                    <td>{new Date(dateData.registTime * 1000).toLocaleDateString()}</td>
                                    <td>{dateData.transferDateLangth}</td>
                                    <td>{inputNumberAutoComma(dateData.totalPrice)}</td>
                                    <td>{inputNumberAutoComma(dateData.fees)}</td>
                                    <td>{inputNumberAutoComma(dateData.transferPrice)}</td>
                                </>
                            ) : activeType === 'club' ? (
                                <>
                            <td>{dateData.clubID}</td>
                            <td>{dateData.clubName}</td>
                            <td>{dateData.registDate}</td>
                            <td>{dateData.transferDateLangth}</td>
                            <td>{inputNumberAutoComma(dateData.totalPrice)}</td>
                            <td>{inputNumberAutoComma(dateData.fees)}</td>
                            <td>{inputNumberAutoComma(dateData.transferPrice)}</td>
                                </>
                            ) : (
                                <>
                                    <td>{dateData.clubID || '-'}</td>
                                    <td>{dateData.clubName || '-'}</td>
                                    <td>{inputNumberAutoComma(dateData.totalPrice)}</td>
                                    <td>{inputNumberAutoComma(dateData.fees)}</td>
                                    <td>{inputNumberAutoComma(dateData.transferPrice)}</td>
                                </>
                            )}
                        </tr>
                        )
                    })
                }
            </tbody>
        </Table>
            </SectionBody>
        </SectionWrapper>
    </Wrapper>
    </>
  );
};

export default React.memo(AdminClubTransferCalculate);
